import React from 'react'
import { Box, Text } from '@chakra-ui/react'

import { useMessageProperties } from './message-provider'
import { formatHumanReadableDate } from './message-helpers'

export default function MessageSpacing() {
    const { message, isFirst, isPastLgThreshold, isPastSmThreshold } =
        useMessageProperties()

    const formatted = formatHumanReadableDate(message.created_at)
        .replace('AM', 'am')
        .replace('PM', 'pm')

    return (
        <>
            {!isPastSmThreshold && <Box h={1} />}
            {isPastSmThreshold && <Box h={2} />}
            {(isPastLgThreshold || isFirst) && (
                <Text
                    mt={4}
                    mb={2}
                    fontSize="11px"
                    textAlign="center"
                    color="gray.500"
                >
                    {formatted}
                </Text>
            )}
        </>
    )
}
